if (!customElements.get('approval-delivery-date')) {
    class ApprovalDeliveryDate extends HTMLElement {

        constructor() {
            super();

            this.key = this.dataset.key;

            this.checkoutErrorModal = document.getElementById('checkout-response-error');
            this.optionSelect = this.querySelector('.line-item-delivery-action');

            try {
                this.deliveryItem = JSON.parse(this.querySelector(`[data-delivery-item="${this.key}"]`)?.innerText);
            } catch (e) {
                if (this.checkoutErrorModal) {
                    this.checkoutErrorModal.html = `File: <b>component-approval-delivery-date.js</b><br />SyntaxError: <b>JSON.parse</b><br />Provider: <b>document.querySelector(\`[data-delivery-item="${this.key}"]\`).innerText</b><br /><hr style="margin: 10px 0 5px;" />`;
                    this.checkoutErrorModal.message = `${e}`;
                    this.checkoutErrorModal.stack = e.stack;
                    this.checkoutErrorModal.open(this);
                }
            }

            try {
                this.item = JSON.parse(document.querySelector(`[data-item="${this.key}"]`)?.innerText);
            } catch (e) {
                if (this.checkoutErrorModal) {
                    this.checkoutErrorModal.html = `File: <b>component-approval-delivery-date.js</b><br />SyntaxError: <b>JSON.parse</b><br />Provider: <b>document.querySelector(\`[data-item="${this.key}"]\`).innerText</b><br /><hr style="margin: 10px 0 5px;" />`;
                    this.checkoutErrorModal.message = `${e}`;
                    this.checkoutErrorModal.stack = e.stack;
                    this.checkoutErrorModal.open(this);
                }
            }
        }

        connectedCallback() {
            this.optionSelect.addEventListener('change', this.handleRadioChanged.bind(this));
        }

        disconnectedCallback() {
            this.optionSelect.removeEventListener('change', this.handleRadioChanged.bind(this));
        }

        async handleRadioChanged(e) {

            window.checkout.loading = true;

            switch (e.target.value) {
                case 'NEXT_DELIVERY_DATE': await this.handleFull(e); break;
                case 'PARTIAL_DELIVERY': await this.handlePartial(e); break;
                case 'CANCELLATION': await this.handleCancel(e); break;
                default: break;
            }

            await window.checkout.handleUpdate();
        }

        async handleCancel(e) {

            if (this.deliveryItem == null) {
                return;
            }

            const id = this.deliveryItem.id || this.item.id;
            LocalCart.updateQuantity(id, 0);            

            this.deliveryItem = null;

            this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);

            return;
        }

        async handleFull(e) {

            const qty = this.item.properties['_original_qty'] ? parseInt(this.item.properties['_original_qty']) : this.item.quantity;

            const addPropsPayload = {
                ...this.item.properties,
                ...(this.item.properties['_possible_next_delivery_date'] ? { '_next_delivery_date': this.item.properties['_possible_next_delivery_date'] } : {}),
                // 'Lieferterminabweichung': 'Die lieferung erfolgt mit einer späteren Anlieferung.',
                '_resolved': true,
                '_canceled': false
            };

            LocalCart.updateProps(this.item.id, addPropsPayload);
            LocalCart.updateQuantity(this.item.id, qty);

            this.deliveryItem = LocalCart.getCartItem(this.item.id);
            this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);
        }

        async handlePartial(e) {

            const qty = this.item.properties['_original_qty'] ? parseInt(this.item.properties['_original_qty']) : this.item.quantity;
            const remainingAvlqty = qty - parseInt(this.item.properties['_available']);

            const itemUpdateProps = {
                ...this.item.properties,
                '_resolved': true,
                '_canceled': false
            }

            LocalCart.updateProps(this.item.id, itemUpdateProps);
            LocalCart.updateQuantity(this.item.id, parseInt(this.item.properties['_available']));

            this.deliveryItem = LocalCart.getCartItem(this.item.id);
            this.querySelector(`[data-delivery-item="${this.key}"]`).innerText = JSON.stringify(this.deliveryItem);

            const line_key = `${this.item.id}:${generateUniqueStringWithTimestamp()}`;
            const addRemainingItemProps = {
                ...(this.item.properties['_price'] ? { '_price': this.item.properties['_price'] } : {}),
                ...(this.item.properties['_identifier'] ? { '_identifier': this.item.properties['_identifier'] } : {}),
                ...(this.item.properties['_deposit_reference'] ? { '_deposit_reference': this.item.properties['_deposit_reference'] } : {}),
                ...(this.item.properties['_possible_next_delivery_date'] ? { '_next_delivery_date': this.item.properties['_possible_next_delivery_date'] } : {}),
                ...(this.item.properties['_max_inventory'] ? { '_max_inventory': this.item.properties['_max_inventory'] } : {})
            }

            LocalCart.addItem({
                id: parseInt(this.item.id),
                key: line_key,
                variant_id: parseInt(this.item.id),
                price: this.item.price,
                quantity: remainingAvlqty,
                properties: addRemainingItemProps,
                handle: this.item.handle,
                title: this.item.title,
                sku: this.item.sku,
                image: this.item.image,
                tags: this.item.tags,
                vendor: this.item.vendor,
                selected_variant: this.item.selected_variant,
                line_price: parseInt(this.item.price) * remainingAvlqty,
                original_line_price: parseInt(this.item.price) * remainingAvlqty,
                final_line_price: parseInt(this.item.price) * remainingAvlqty
            });

        }
    }

    customElements.define('approval-delivery-date', ApprovalDeliveryDate);
}